import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import {
    RECONCILATION_SETTING_ADD,
    RECONCILATION_SETTING_SELECT,
    LOGOUT
} from 'ConstComponents';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CustomeAlert } from 'Components/Alert/Alert';
import { useHistory } from 'react-router';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MESSAGE_CLOSE_AFTER } from 'Components/Helper/Messages';

export const ReconciliationSetting = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loading, setLoading] = useState(false);
    const [Reconciliationsetting, setReconciliationsetting] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    var FormObj = {
        Amount: '',
        STVNo: '',
        Date: '',
        Channel: ''
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);

        setIsError(false);
        setLoading(true);
        var response = await RECONCILATION_SETTING_ADD(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setLoading(false);
            setSeverity('error');
            return;
        }

        resetForm(FormObj);

        setTimeout(() => {
            history.push('/Reconciliation/ReconciliationSetting');
        }, MESSAGE_CLOSE_AFTER);
        selectSetting();
    };

    useEffect(() => {
        selectSetting();
        createColumns();
    }, []);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'FirmID',
            srno: true
        });

        columns.push({
            label: 'STBNo',
            name: 'STVNo'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount'
        });

        setMainColumns(columns);
    };

    const selectSetting = async () => {
        const response = await RECONCILATION_SETTING_SELECT();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var data = JSON.parse(response.data);
        setReconciliationsetting(data);
    };

    const ReconcilationScheama = Yup.object({
        Amount: Yup.string()
            .trim()
            .required('Please enter valid  string for Amount.'),
        STVNo: Yup.string()
            .trim()
            .required('Please enter valid  string for STBNo.')
    });
    const resethandle = resetForm => {};
    return (
        <>
            {isError ? (
                <CustomeAlert
                    isOpen={isError}
                    message={responseMessage}
                    severity={severity}
                    onCloseCallback={alertState => {
                        setIsError(alertState);
                    }}
                />
            ) : null}
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={ReconcilationScheama}
                onSubmit={submithandle}
                onReset={resethandle}
                render={formProps => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Reconcilation Setting Details
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={3}>
                                            <MaterialTextField
                                                label="STBNo"
                                                name="STVNo"
                                                type="text"
                                                title="STBNo"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3}>
                                            <MaterialTextField
                                                label="Amount"
                                                name="Amount"
                                                type="text"
                                                title="Amount"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Register"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            //  disabled={loading}
                                        >
                                            Add
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>

                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />

            <ReactTable List={Reconciliationsetting} columns={mainColumns} />
        </>
    );
};
